const zIndicies = {
    appBar: 4999,
    chatBar: 900,
    desktopChatTitleRow: 1003,

    // Job flyout
    jobFlyout: 1001,
    // Nested
    jobCloseButton: 4000,
    jobBookmarkButton: 4800,

    // Resource Flyout
    resourceFlyoutTopBar: 10000,
    resourceCloseButton: 10001,
    resourceBookmarkButton: 10001,


    flyoutPanelMobile: 11000,
    flyoutPanelDesktop: 2000,
    flyoutPanelNested: 10002,

    resourceListsModalDesktop: 20000,
    resourceListsModalMobile: 20000,


    mobileNavDrawerBg: 5000,
    mobileAppBar: 1002,
    appDrawerMobile: 9999,
    appDrawerDesktop: 99,

    modal: 20000,

    sidebar: 9999,
};

export default zIndicies;